import { Injectable, Inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import isString from 'lodash-es/isString';
import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';
import {
  errorCodeExtractor,
  ErrorExtractorFn,
  errorMessageExtractor
} from './errors.utils';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(
    @Inject(errorCodeExtractor)
    private _errCodeExtractor: ErrorExtractorFn,
    @Inject(errorMessageExtractor)
    private _errMessageExtractor: ErrorExtractorFn
  ) { }

  #getErrType(err: HttpErrorResponse): 'string' | 'object' | 'array' {

    let errType: 'string' | 'object' | 'array';

    if (isString(err.error)) {
      errType = 'string';
    }

    if (isObject(err.error)) {
      errType = 'object';
    }

    if (isArray(err.error)) {
      errType = 'array';
    }

    return errType;

  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next
      .handle(req)
      .pipe(
        catchError((err: HttpErrorResponse) => {

          if (err.error instanceof Blob) {
            return from(err.error.text()).pipe(
              map((text) => {
                try {
                  return JSON.parse(text);
                } catch {
                  throw text;
                }
              }),
              switchMap((parsedError) => {
                const errUpdated = {
                  ...err,
                  ...{ error: parsedError }
                };
                return throwError(() => ({
                  code: this._errCodeExtractor(errUpdated),
                  message: this._errMessageExtractor(errUpdated),
                  status: errUpdated?.status,
                  originalError: errUpdated,
                  errType: this.#getErrType(errUpdated)
                }))
              })
            );
          }

          return throwError({
            code: this._errCodeExtractor(err),
            message: this._errMessageExtractor(err),
            status: err?.status,
            originalError: err,
            errType: this.#getErrType(err)
          });

        })
      );
  }
}
